import React from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-scroll";

import sana from "../assets/images/sana.png";
import fondo from "../assets/images/hero-ortodoncia.jpg";
import logo from "../assets/images/Sana-logo-blanco.png";

import consulta from "../assets/images/Carrusel/consulta.jpg";
import equipo from "../assets/images/Carrusel/equipo.jpg";
import ligas from "../assets/images/Carrusel/ligas.jpg";
import paciente from "../assets/images/Carrusel/paciente.jpg";
import radiografia from "../assets/images/Carrusel/radiografia.jpg";
import revision from "../assets/images/Carrusel/revision.jpg";

import ortodoncia from "../assets/images/Servicios/ortodoncia.jpg";
import cirugiaMaxilofacial from "../assets/images/Servicios/Cirugia-Maxilofacial.jpeg";
import endodoncia from "../assets/images/Servicios/endodoncia.jpg";
import rehabilitacionBucal from "../assets/images/Servicios/Rehabilitacion-Bucal.jpg";

import "../assets/styles/Home.css";

const imagenesCarrusel = [consulta, equipo, ligas, paciente, radiografia, revision];

const slides = [];
for (let i = 0; i < imagenesCarrusel.length; i += 3) {
    slides.push(imagenesCarrusel.slice(i, i + 3));
}

function Home() {
    return (
        <>
            <Helmet>
                <link
                    rel="stylesheet"
                    href="https://cdn.jsdelivr.net/npm/bootstrap-icons@1.10.5/font/bootstrap-icons.css"
                />
            </Helmet>

            <section
                id="inicio"
                className="d-flex align-items-center text-white"
                style={{
                    height: "60vh",
                    backgroundImage: `
                        linear-gradient(to right, rgba(67, 0, 124, 1), rgba(107, 76, 154, 0.3)),
                        url(${fondo})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                }}
            >
                <div className="container text-start">
                    <img src={logo} alt="Sana Logo" style={{ height: "80px" }} className="mb-3" />
                    <h3 className="text-uppercase letter-spacing mb-1">Servicios Dentales</h3>
                    <p className="fw-bold mb-4">Orizaba</p>
                    <a
                        href="https://wa.me/5212721986870"
                        className="btn btn-success px-4 py-2 fw-semibold"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Agendar Cita
                    </a>
                </div>
            </section>

            <section id="servicios" className="py-5 bg-light">
                <div className="container">
                    <h2 className="text-center fw-bold mb-5 text-title">Nuestros Servicios Destacados</h2>
                    <div className="row">

                        <div className="col-md-6 col-lg-3 mb-4">
                            <div className="card shadow-sm h-100 text-center border-0">
                                <div className="card-body">
                                    <h5 className="fw-bold services-title">Ortodoncia</h5>
                                    <p className="card-text text-secondary">Corrige la posición de tus dientes para mejorar tu sonrisa y salud bucal.</p>
                                    <img src={ortodoncia} alt="Ortodoncia" className="img-fluid my-3 rounded servicio-img" />
                                    <a href="https://wa.me/5212721986870" className="btn btn-outline">Agendar cita</a>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-6 col-lg-3 mb-4">
                            <div className="card shadow-sm h-100 text-center border-0">
                                <div className="card-body">
                                    <h5 className="fw-bold services-title">Cirugía Maxilofacial</h5>
                                    <p className="card-text text-secondary">Tratamientos quirúrgicos para problemas en mandíbula y boca.</p>
                                    <img src={cirugiaMaxilofacial} alt="Cirugía Maxilofacial" className="img-fluid my-3 rounded servicio-img" />
                                    <a href="https://wa.me/5212721986870" className="btn btn-outline">Agendar cita</a>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-6 col-lg-3 mb-4">
                            <div className="card shadow-sm h-100 text-center border-0">
                                <div className="card-body">
                                    <h5 className="fw-bold services-title">Endodoncia</h5>
                                    <p className="card-text text-secondary">Salva tus dientes eliminando infecciones del nervio dental.</p>
                                    <img src={endodoncia} alt="Endodoncia" className="img-fluid my-3 rounded servicio-img" />
                                    <a href="https://wa.me/5212721986870" className="btn btn-outline">Agendar cita</a>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-6 col-lg-3 mb-4">
                            <div className="card shadow-sm h-100 text-center border-0">
                                <div className="card-body">
                                    <h5 className="fw-bold services-title">Rehabilitación Bucal</h5>
                                    <p className="card-text text-secondary">Recupera la función y estética de tu boca con tratamientos integrales.</p>
                                    <img src={rehabilitacionBucal} alt="Rehabilitación Bucal" className="img-fluid my-3 rounded servicio-img" />
                                    <a href="https://wa.me/5212721986870" className="btn btn-outline">Agendar cita</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section id="ubicacion" className="py-5 bg-white">
                <div className="container">
                    <h2 className="text-center fw-bold mb-3 text-title">
                        Encuéntranos en <span className="text-purple">Orizaba</span>
                    </h2>
                    <p className="text-center mb-5 text-subtitle">
                        Visítanos en nuestra clínica. Estamos listos para atenderte con la mejor calidad y servicio.
                    </p>

                    <div className="row align-items-center">
                        <div className="col-md-6 text-info-ubicacion">
                            <h5 className="fw-bold mb-3">Información de Contacto</h5>
                            <p className="mb-4">
                                <i className="bi bi-geo-alt-fill me-2 text-purple"></i>
                                Oriente 4 315, Centro, 94300 Orizaba, Ver, México.
                            </p>
                            <p className="mb-4">
                                <i className="bi bi-telephone-fill me-2 text-purple"></i>
                                272 198 6870
                            </p>
                            <p className="mb-4">
                                <i className="bi bi-envelope-fill me-2 text-purple"></i>
                                sanaservidental@gmail.com
                            </p>
                            <p className="mb-4">
                                <i className="bi bi-clock-fill me-2 text-purple"></i>
                                <strong>Horarios de Atención:</strong><br />
                                Lunes a Viernes: 10:00 AM - 2:00 PM, 4:00 PM - 8:00 PM <br />
                                Sábado: 10:00 AM - 3:00 PM <br />
                                Domingo: Cerrado
                            </p>
                        </div>

                        <div className="col-md-6">
                            <div className="ratio ratio-4x3 shadow rounded">
                                <iframe
                                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1464.5127006753826!2d-97.1017422153209!3d18.847630104283535!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x85c502a51d93e64b%3A0xe07153173edefbb4!2sSANA%20-%20DENTISTA%20%2F%20ORTODONCIA!5e0!3m2!1ses-419!2smx!4v1747315321611!5m2!1ses-419!2smx"
                                    style={{ border: 0 }}
                                    allowFullScreen=""
                                    loading="lazy"
                                    referrerPolicy="no-referrer-when-downgrade"
                                ></iframe>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section id="opiniones" className="reviews-section">
                <div className="text-center mb-5">
                    <h2 className="text-title reviews-titlev fw-bold">Lo que nuestros pacientes <span className="text-purple">opinan en Google</span></h2>
                    <p className="mb-5 descripcion-opiniones">
                        La satisfacción de nuestros pacientes es nuestra mayor recompensa. Lee sus experiencias.
                    </p>
                </div>
                <div className="reviews-grid">
                    {[
                        {
                            nombre: "Antonio Norris",
                            texto: "Excelente servicio. Buenos precios y atención de calidad. Me encantó cómo quedaron mis dientes. ¡Recomendado al 100%!"
                        },
                        {
                            nombre: "Yaretzi Adriana Hernández",
                            texto: "Servicio 10/10. Muy buena atención, trato amable y excelentes resultados. ¡Gracias!"
                        },
                        {
                            nombre: "Luis Herrera",
                            texto: "Muy profesionales y atentos. Me sentí cómodo durante todo el tratamiento. Sin duda volveré."
                        },
                        {
                            nombre: "Ana Sofía Martínez",
                            texto: "Trato humano, instalaciones limpias y modernas. Todo el equipo súper amable. ¡Los recomiendo muchísimo!"
                        }
                    ].map((opinion, i) => (
                        <div className="review-card" key={i}>
                            <div className="review-name">{opinion.nombre}</div>
                            <div className="review-stars">
                                {[...Array(5)].map((_, idx) => (
                                    <i className="fas fa-star" key={idx}></i>
                                ))}
                            </div>
                            <p className="review-text">{opinion.texto}</p>
                        </div>
                    ))}
                </div>
            </section>

            <section id="redes" className="py-5 bg-white">
                <div className="container text-center mb-5">
                    <h2 className="fw-bold text-title mb-3">
                        Síguenos en nuestras <span className="text-purple">Redes Sociales</span>
                    </h2>
                    <p className="mb-5 descripcion-redes">
                        Mantente al día con nuestras novedades, consejos de salud dental y promociones especiales.
                    </p>

                    <div className="row justify-content-center">
                        {[
                            {
                                nombre: "Facebook",
                                user: "@SANA",
                                icono: "bi bi-facebook",
                                color: "#e8f0fe",
                                textColor: "#1877F2",
                                url: "https://www.facebook.com/share/19snh9vM7J/?mibextid=wwXIfr"
                            },
                            {
                                nombre: "Instagram",
                                user: "@ortodoncia_sana",
                                icono: "bi bi-instagram",
                                color: "#fce6ec",
                                textColor: "#E1306C",
                                url: "https://www.instagram.com/ortodoncia_sana?igsh=YWhyNzRudHNpMmNz"
                            },
                            {
                                nombre: "TikTok",
                                user: "@jcgsana",
                                icono: "bi bi-tiktok",
                                color: "#f0f0f0",
                                textColor: "#000000",
                                url: "https://www.tiktok.com/@jcgsana?is_from_webapp=1&sender_device=pc"
                            }
                        ].map((red, index) => (
                            <div className="col-md-3 mb-4" key={index}>
                                <a
                                    href={red.url}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-decoration-none social-box d-block h-100"
                                    style={{
                                        backgroundColor: red.color,
                                        borderRadius: "0.5rem",
                                    }}
                                >
                                    <div className="p-4 d-flex flex-column justify-content-center align-items-center">
                                        <i className={`${red.icono} fs-1 mb-2`} style={{ color: red.textColor }}></i>
                                        <h5 className="mb-1" style={{ color: red.textColor }}>{red.nombre}</h5>
                                        <p className="text-muted mb-0">{red.user}</p>
                                    </div>
                                </a>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

             <section id="portafolio" className="py-5 bg-light">
                <div className="container text-center">
                    <h2 className="text-center fw-bold mb-5 text-title">Galería</h2>

                    <div id="trabajoCarrusel" className="carousel slide" data-bs-ride="carousel">
                        <div className="carousel-inner rounded shadow">
                            {slides.map((grupo, index) => (
                                <div className={`carousel-item ${index === 0 ? "active" : ""}`} key={index}>
                                    {/* Pantallas grandes: 3 imágenes */}
                                    <div className="d-none d-md-block">
                                        <div className="row justify-content-center">
                                            {grupo.map((imagen, i) => (
                                                <div className="col-md-4" key={i}>
                                                    <img src={imagen} className="d-block w-100 img-cuadrada" alt={`Slide ${index}-${i}`} />
                                                </div>
                                            ))}
                                        </div>
                                    </div>

                                    {/* Pantallas pequeñas: solo 1 imagen */}
                                    <div className="d-block d-md-none">
                                        <div className="text-center">
                                            <img src={grupo[0]} className="d-block w-100 img-cuadrada mx-auto" alt={`Slide mobile ${index}`} />
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>

                        {/* Controles */}
                        <button className="carousel-control-prev" type="button" data-bs-target="#trabajoCarrusel" data-bs-slide="prev">
                            <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                            <span className="visually-hidden">Anterior</span>
                        </button>
                        <button className="carousel-control-next" type="button" data-bs-target="#trabajoCarrusel" data-bs-slide="next">
                            <span className="carousel-control-next-icon" aria-hidden="true"></span>
                            <span className="visually-hidden">Siguiente</span>
                        </button>
                    </div>
                </div>
            </section>

            <a
                href="https://wa.me/5212721986870"
                className="whatsapp-float"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Enviar mensaje por WhatsApp"
            >
                <i className="bi bi-whatsapp"></i>
            </a>

        </>
    );
}

export default Home;
